import React from 'react';
import { Badge, Button } from 'react-bootstrap';
import { FaEye, FaVideo } from 'react-icons/fa';

export const getMeetingColumns = ({ handleView, handleJoin }) => [
  {
    accessorKey: 'index',
    header: '#',
    cell: (info) => <span className="opacity-50 text-white">{info.row.index + 1}</span>,
    enableSorting: false,
  },
  {
    accessorKey: 'projectName',
    header: 'Project',
    cell: (info) => <span className="text-warning fw-bold">{info.getValue() || 'N/A'}</span>,
  },
  {
    accessorKey: 'roleName',
    header: 'Role',
    cell: (info) => <span className="fw-bold text-white">{info.getValue() || 'N/A'}</span>,
  },
  {
    accessorKey: 'applicationId',
    header: 'Application ID',
    cell: (info) => <span className="text-info font-monospace small">#{info.getValue()}</span>,
  },
  {
    accessorKey: 'bookingType',
    header: 'Meeting Type',
    cell: (info) => (
      <Badge bg="dark" className="border border-secondary text-uppercase text-light" style={{ fontSize: '10px' }}>
        {(info.getValue() || 'AUDITION').replaceAll('_', ' ')}
      </Badge>
    ),
  },
  {
    accessorKey: 'formattedDate',
    header: 'Date',
    cell: (info) => <span className="text-white opacity-75">{info.getValue()}</span>,
  },
  {
    accessorKey: 'formattedTime',
    header: 'Time',
    cell: (info) => <span className="text-info small fw-bold">{info.getValue()}</span>,
  },
  {
    accessorKey: 'statusVal',
    header: 'Status',
    cell: (info) => {
      const val = info.getValue() || 'BOOKED';
      const isExpired = val === 'EXPIRED';
      return (
        <span className={`pmp-status-tag ${isExpired ? 'pmp-status-expired' : 'pmp-status-active'}`}>
          {val}
        </span>
      );
    },
  },
  {
    id: 'actions',
    header: 'Actions',
    cell: (info) => {
      const item = info.row.original;
      const isExpired = item.statusVal === 'EXPIRED';
      return (
        <div className="d-flex align-items-center gap-2">
          <Button
            variant="outline-info"
            size="sm"
            className="p-1 px-2"
            title="View Details"
            onClick={() => handleView(item)}
            style={{ fontSize: '12px' }}
          >
            <FaEye />
          </Button>

          <Button
            variant={isExpired ? "secondary" : "success"}
            size="sm"
            className="p-1 px-2 fw-bold d-flex align-items-center gap-1"
            disabled={isExpired}
            title={isExpired ? "Meeting Expired" : "Join Meeting"}
            onClick={() => handleJoin(item)}
            style={{ fontSize: '11px' }}
          >
            <FaVideo /> Join
          </Button>
        </div>
      );
    },
  },
];
